import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {useFunds, CreateFundDTO} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {useNavigate} from 'react-router';

type UseAddFundFormProps = {
  navigateAfterSuccess?: boolean;
};

export const useAddFundForm = ({navigateAfterSuccess = true}: UseAddFundFormProps = {}) => {
  const navigate = useNavigate();
  const {
    nameSchema,
    shortDescriptionSchema,
    detailedDescriptionSchema,
    emailNotRequiredSchema,
    phoneNumberNotRequiredSchema,
    websiteSchema,
  } = useSchemes();

  const {createFundMutation} = useFunds();

  const onSubmit = async (values: CreateFundDTO) => {
    try {
      await createFundMutation.mutateAsync(values);
      if (navigateAfterSuccess) {
        navigate('/fundraisings/funds');
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      shortDescription: '',
      detailedDescription: '',
      phoneNumber: '',
      email: '',
      website: '',
    },
    validateOnChange: true,
    validationSchema: Yup.object({
      name: nameSchema,
      shortDescription: shortDescriptionSchema,
      detailedDescription: detailedDescriptionSchema,
      email: emailNotRequiredSchema,
      phoneNumber: phoneNumberNotRequiredSchema,
      website: websiteSchema,
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createFundMutation.isPending,
    submitError: createFundMutation.error
      ? (createFundMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    submitForm: () => formik.handleSubmit(),
  };
};
